var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad" },
    [
      _vm.showUsarDadosCadastrante()
        ? _c(
            "el-row",
            { staticClass: "usar-dados-cadastrante" },
            [
              _c(
                "el-col",
                [
                  _c("el-checkbox", {
                    attrs: { label: "Usar dados do cadastrante" },
                    on: { change: _vm.usarDadosCadastrante },
                    model: {
                      value: _vm.dadosCadastrante,
                      callback: function($$v) {
                        _vm.dadosCadastrante = $$v
                      },
                      expression: "dadosCadastrante"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.cpf.validacao"
                  ),
                  name: _vm.nomeAba + "/CPF do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.cpf.label"
                            )
                          }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "CPF" },
                          model: {
                            value:
                              _vm.cadastroFormulario.interessado.pessoa
                                .pessoaFisica.cpf,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica,
                                "cpf",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.interessado.pessoa.pessoaFisica.cpf"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.nome.validacao"
                  ),
                  name: _vm.nomeAba + "/Nome do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.nome.label"
                            )
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Nome", maxlength: "300" },
                          model: {
                            value:
                              _vm.cadastroFormulario.interessado.pessoa
                                .pessoaFisica.nome,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica,
                                "nome",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.interessado.pessoa.pessoaFisica.nome"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.apelido.validacao"
                  ),
                  name: _vm.nomeAba + "/Apelido do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.apelido.label"
                            ),
                            required: _vm.camposValidacao(
                              "interessado.pessoaFisica.apelido.obrigatorio"
                            )
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            type: "text",
                            maxlength: "300",
                            name: "apelido"
                          },
                          model: {
                            value:
                              _vm.cadastroFormulario.interessado.pessoa
                                .pessoaFisica.apelido,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica,
                                "apelido",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.interessado.pessoa.pessoaFisica.apelido"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.rg.validacao"
                  ),
                  name: _vm.nomeAba + "/RG do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.rg.label"
                            ),
                            required: _vm.camposValidacao(
                              "interessado.pessoaFisica.rg.obrigatorio"
                            )
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "RG", maxlength: "30" },
                          model: {
                            value:
                              _vm.cadastroFormulario.interessado.pessoa
                                .pessoaFisica.rg,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica,
                                "rg",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.interessado.pessoa.pessoaFisica.rg"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.orgaoExpedidor.validacao"
                  ),
                  name: _vm.nomeAba + "/Órgão Expedidor do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.orgaoExpedidor.label"
                            ),
                            required: _vm.camposValidacao(
                              "interessado.pessoaFisica.orgaoExpedidor.obrigatorio"
                            )
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Órgão expedidor",
                              "no-match-text": "Nenhum orgão encontrado",
                              placeholder: "Selecione",
                              "value-key": "id",
                              filterable: "filterable",
                              clearable: "clearable"
                            },
                            model: {
                              value: _vm.interessadoOrgaoExpedidor.nome,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.interessadoOrgaoExpedidor,
                                  "nome",
                                  $$v
                                )
                              },
                              expression: "interessadoOrgaoExpedidor.nome"
                            }
                          },
                          _vm._l(_vm.orgaosExpedidores, function(
                            orgaoExpedidor
                          ) {
                            return _c("el-option", {
                              key: orgaoExpedidor.id,
                              attrs: {
                                label: _vm.getName(orgaoExpedidor),
                                value: orgaoExpedidor
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.orgaoExpedidor.validacao"
                  ),
                  name: _vm.nomeAba + "/UF do RG do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "UF do RG:",
                            required: _vm.camposValidacao(
                              "interessado.pessoaFisica.orgaoExpedidor.obrigatorio"
                            )
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "UF do RG",
                              "no-match-text": "Nenhuma UF encontrada",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable",
                              disabled: !_vm.interessadoOrgaoExpedidor.nome
                            },
                            model: {
                              value: _vm.interessadoOrgaoExpedidor.codigoEstado,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.interessadoOrgaoExpedidor,
                                  "codigoEstado",
                                  $$v
                                )
                              },
                              expression:
                                "interessadoOrgaoExpedidor.codigoEstado"
                            }
                          },
                          _vm._l(_vm.estadosBr, function(estado) {
                            return _c("el-option", {
                              key: estado.codigo,
                              attrs: { label: estado.nome, value: estado }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-input-telefone", {
                attrs: {
                  telefones:
                    _vm.cadastroFormulario.interessado.pessoa.telefones,
                  nomeAba: _vm.nomeAba,
                  requiredTelefones: true,
                  observer: _vm.observer
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.email.validacao"
                  ),
                  name: _vm.nomeAba + "/E-mail do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.email.label"
                            )
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "E-mail",
                            maxlength: "100",
                            label: "email"
                          },
                          model: {
                            value:
                              _vm.cadastroFormulario.interessado.pessoa.email,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.interessado.pessoa,
                                "email",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.interessado.pessoa.email"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "row" },
        [
          _c(
            "el-col",
            { staticClass: "coluna", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.nacionalidade.validacao"
                  ),
                  name: _vm.nomeAba + "/Nacionalidade do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.nacionalidade.label"
                            )
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Nacionalidade",
                              "no-match-text":
                                "Nenhuma nacionalidade encontrada",
                              placeholder: "Selecione",
                              "value-key": "id",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            model: {
                              value:
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica.nacionalidade,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cadastroFormulario.interessado.pessoa
                                    .pessoaFisica,
                                  "nacionalidade",
                                  $$v
                                )
                              },
                              expression:
                                "cadastroFormulario.interessado.pessoa.pessoaFisica.nacionalidade"
                            }
                          },
                          _vm._l(_vm.gentilico, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              staticClass: "selectNacionalidade",
                              attrs: {
                                label: item.gentilico + " - " + item.nomePais,
                                value: item.sigla
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.naturalidadeInteressado
            ? _c(
                "el-col",
                { staticClass: "coluna", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules:
                        _vm.camposValidacao(
                          "interessado.pessoaFisica.ufNaturalidade.validacao"
                        ) && _vm.isBrasileiro
                          ? "required"
                          : "",
                      name: _vm.nomeAba + "/UF de Naturalidade do interessado"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: _vm.camposValidacao(
                                    "interessado.pessoaFisica.ufNaturalidade.label"
                                  ),
                                  required:
                                    _vm.isBrasileiro &&
                                    _vm.camposValidacao(
                                      "interessado.pessoaFisica.ufNaturalidade.obrigatorio"
                                    )
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    "no-match-text": "Nenhuma UF encontrada",
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    disabled: !_vm.isBrasileiro,
                                    name: "UF de naturalidade"
                                  },
                                  on: { change: _vm.setMunicipioUf },
                                  model: {
                                    value:
                                      _vm.naturalidadeInteressado.codigoEstado,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.naturalidadeInteressado,
                                        "codigoEstado",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "naturalidadeInteressado.codigoEstado"
                                  }
                                },
                                _vm._l(_vm.estadosBr, function(item) {
                                  return _c("el-option", {
                                    key: item.codigo,
                                    attrs: {
                                      label: item.nome,
                                      value: item.codigo
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4137434735
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.naturalidadeInteressado
            ? _c(
                "el-col",
                { staticClass: "coluna-ultimo", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules:
                        _vm.camposValidacao(
                          "interessado.pessoaFisica.ufNaturalidade.validacao"
                        ) && _vm.isBrasileiro
                          ? "required"
                          : "",
                      name:
                        _vm.nomeAba +
                        "/Município de Naturalidade do interessado"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Município de naturalidade:",
                                  required:
                                    _vm.isBrasileiro &&
                                    _vm.camposValidacao(
                                      "interessado.pessoaFisica.ufNaturalidade.obrigatorio"
                                    )
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Município de Naturalidade",
                                    "no-match-text":
                                      "Nenhum município encontrado",
                                    placeholder: "Selecione",
                                    filterable: "filterable",
                                    disabled: !_vm.isBrasileiro,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.naturalidadeInteressado.nome,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.naturalidadeInteressado,
                                        "nome",
                                        $$v
                                      )
                                    },
                                    expression: "naturalidadeInteressado.nome"
                                  }
                                },
                                _vm._l(
                                  _vm.municipiosNaturalidadeInteressado,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: { label: item.nome, value: item }
                                    })
                                  }
                                ),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      804635900
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.estadoCivil.validacao"
                  ),
                  name: _vm.nomeAba + "/Estado civil"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.estadoCivil.label"
                            ),
                            required: _vm.camposValidacao(
                              "interessado.pessoaFisica.estadoCivil.obrigatorio"
                            )
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Estado civil",
                              "value-key": "codigo",
                              "no-match-text": "Nenhum estado civil encontrado",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            on: { change: _vm.changeEstadoCivil },
                            model: {
                              value:
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica.estadoCivil,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cadastroFormulario.interessado.pessoa
                                    .pessoaFisica,
                                  "estadoCivil",
                                  $$v
                                )
                              },
                              expression:
                                "cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil"
                            }
                          },
                          _vm._l(_vm.estadosCivil, function(item) {
                            return _c("el-option", {
                              key: item.codigo,
                              attrs: { label: item.nome, value: item.codigo }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.camposValidacao(
                    "interessado.pessoaFisica.dataNascimento.validacao"
                  ),
                  name: _vm.nomeAba + "/Data de nascimento do interessado"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.camposValidacao(
                              "interessado.pessoaFisica.dataNascimento.label"
                            ),
                            required: _vm.camposValidacao(
                              "interessado.pessoaFisica.dataNascimentos.obrigatorio"
                            )
                          }
                        }),
                        _c("el-date-picker", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##/##/#####",
                              expression: "'##/##/#####'"
                            }
                          ],
                          staticClass: "input full-width",
                          class: { erro: errors.length },
                          attrs: {
                            type: "date",
                            name: "Data de nascimento",
                            placeholder: "Selecione",
                            format: "dd/MM/yyyy",
                            "picker-options": _vm.pickerOptions
                          },
                          model: {
                            value:
                              _vm.cadastroFormulario.interessado.pessoa
                                .pessoaFisica.dataNascimento,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.interessado.pessoa
                                  .pessoaFisica,
                                "dataNascimento",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.interessado.pessoa.pessoaFisica.dataNascimento"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.hasConjuge &&
      _vm.cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil !==
        "VIUVO"
        ? _c(
            "div",
            [
              _c("app-divider", { attrs: { label: "Cônjuge" } }),
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.cpf.validacao"
                          ),
                          name: _vm.nomeAba + "/CPF do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.cpf.label"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "###.###.###-##",
                                        expression: "'###.###.###-##'"
                                      }
                                    ],
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "CPF" },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.cpf,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "cpf",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.cpf"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2912505028
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.nome.validacao"
                          ),
                          name: _vm.nomeAba + "/Nome do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.nome.label"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "Nome", maxlength: "300" },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.nome,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "nome",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nome"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3371056940
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "labelDiv", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.apelido.validacao"
                          ),
                          name: _vm.nomeAba + "/Apelido do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.apelido.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.apelido.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      type: "text",
                                      maxlength: "300",
                                      name: "apelido"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.apelido,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "apelido",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.apelido"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1934345267
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "labelDiv", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.rg.validacao"
                          ),
                          name: _vm.nomeAba + "/RG do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.rg.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.rg.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "RG", maxlength: "30" },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.rg,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "rg",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.rg"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1138670224
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.orgaoExpedidor.validacao"
                          ),
                          name: _vm.nomeAba + "/Órgão Expedidor do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.orgaoExpedidor.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.orgaoExpedidor.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input select",
                                      class: { erro: errors.length },
                                      attrs: {
                                        name: "Órgão expedidor",
                                        "no-match-text":
                                          "Nenhum orgão encontrado",
                                        placeholder: "Selecione",
                                        "value-key": "id",
                                        filterable: "filterable",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.conjugeOrgaoExpedidor.nome,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.conjugeOrgaoExpedidor,
                                            "nome",
                                            $$v
                                          )
                                        },
                                        expression: "conjugeOrgaoExpedidor.nome"
                                      }
                                    },
                                    _vm._l(_vm.orgaosExpedidores, function(
                                      orgaoExpedidor
                                    ) {
                                      return _c("el-option", {
                                        key: orgaoExpedidor.id,
                                        attrs: {
                                          label: _vm.getName(orgaoExpedidor),
                                          value: orgaoExpedidor
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1509303125
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.rg.validacao"
                          ),
                          name: _vm.nomeAba + "/UF do RG do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "UF do RG:",
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.rg.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input select",
                                      class: { erro: errors.length },
                                      attrs: {
                                        name: "UF do RG",
                                        "no-match-text":
                                          "Nenhuma UF encontrada",
                                        placeholder: "Selecione",
                                        clearable: "clearable",
                                        filterable: "filterable",
                                        disabled: !_vm.conjugeOrgaoExpedidor
                                          .nome
                                      },
                                      model: {
                                        value:
                                          _vm.conjugeOrgaoExpedidor
                                            .codigoEstado,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.conjugeOrgaoExpedidor,
                                            "codigoEstado",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "conjugeOrgaoExpedidor.codigoEstado"
                                      }
                                    },
                                    _vm._l(_vm.estadosBr, function(estado) {
                                      return _c("el-option", {
                                        key: estado.codigo,
                                        attrs: {
                                          label: estado.nome,
                                          value: estado
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4200415493
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "labelDiv row" },
                [
                  _c(
                    "el-col",
                    { staticClass: "coluna", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.nacionalidade.validacao"
                          ),
                          name: _vm.nomeAba + "/Nacionalidade do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.nacionalidade.label"
                                      )
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input select",
                                      class: { erro: errors.length },
                                      attrs: {
                                        name: "Nacionalidade",
                                        "no-match-text":
                                          "Nenhuma nacionalidade encontrada",
                                        placeholder: "Selecione",
                                        "value-key": "id",
                                        clearable: "clearable",
                                        filterable: "filterable"
                                      },
                                      model: {
                                        value:
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica
                                            .nacionalidade,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cadastroFormulario.interessado
                                              .conjuge.pessoa.pessoaFisica,
                                            "nacionalidade",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nacionalidade"
                                      }
                                    },
                                    _vm._l(_vm.gentilico, function(item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        staticClass: "selectNacionalidade",
                                        attrs: {
                                          label:
                                            item.gentilico +
                                            " - " +
                                            item.nomePais,
                                          value: item.sigla
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          134206864
                        )
                      })
                    ],
                    1
                  ),
                  _vm.naturalidadeConjuge
                    ? _c(
                        "el-col",
                        { staticClass: "coluna", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules:
                                _vm.camposValidacao(
                                  "conjuge.pessoaFisica.ufNaturalidade.validacao"
                                ) && _vm.isBrasileiroConjuge
                                  ? "required"
                                  : "",
                              name:
                                _vm.nomeAba + "/UF de Naturalidade do cônjuge"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: _vm.camposValidacao(
                                            "conjuge.pessoaFisica.ufNaturalidade.label"
                                          ),
                                          required:
                                            _vm.isBrasileiroConjuge &&
                                            _vm.camposValidacao(
                                              "conjuge.pessoaFisica.ufNaturalidade.obrigatorio"
                                            )
                                        }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "input select",
                                          class: { erro: errors.length },
                                          attrs: {
                                            "no-match-text":
                                              "Nenhuma UF encontrada",
                                            placeholder: "Selecione",
                                            clearable: "clearable",
                                            filterable: "filterable",
                                            disabled: !_vm.isBrasileiroConjuge,
                                            name: "UF de naturalidade"
                                          },
                                          on: {
                                            change: _vm.setMunicipioUfConjuge
                                          },
                                          model: {
                                            value:
                                              _vm.naturalidadeConjuge
                                                .codigoEstado,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.naturalidadeConjuge,
                                                "codigoEstado",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "naturalidadeConjuge.codigoEstado"
                                          }
                                        },
                                        _vm._l(_vm.estadosBr, function(item) {
                                          return _c("el-option", {
                                            key: item.codigo,
                                            attrs: {
                                              label: item.nome,
                                              value: item.codigo
                                            }
                                          })
                                        }),
                                        1
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2684936676
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.naturalidadeConjuge
                    ? _c(
                        "el-col",
                        { staticClass: "coluna-ultimo", attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules:
                                _vm.camposValidacao(
                                  "conjuge.pessoaFisica.ufNaturalidade.validacao"
                                ) && _vm.isBrasileiroConjuge
                                  ? "required"
                                  : "",
                              name:
                                _vm.nomeAba +
                                "/Município de Naturalidade do cônjuge"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Município de naturalidade:",
                                          required:
                                            _vm.isBrasileiroConjuge &&
                                            _vm.camposValidacao(
                                              "conjuge.pessoaFisica.naturalidade.obrigatorio"
                                            )
                                        }
                                      }),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "input select",
                                          class: { erro: errors.length },
                                          attrs: {
                                            name: "Município de Naturalidade",
                                            "no-match-text":
                                              "Nenhum município encontrado",
                                            placeholder: "Selecione",
                                            filterable: "filterable",
                                            disabled:
                                              !_vm.isBrasileiroConjuge &&
                                              !_vm.naturalidadeConjuge
                                                .codigoEstado,
                                            "value-key": "id"
                                          },
                                          model: {
                                            value: _vm.naturalidadeConjuge.nome,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.naturalidadeConjuge,
                                                "nome",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "naturalidadeConjuge.nome"
                                          }
                                        },
                                        _vm._l(
                                          _vm.municipiosNaturalidadeConjuge,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.nome,
                                                value: item
                                              }
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              674058134
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.dataNascimento.validacao"
                          ),
                          name: _vm.nomeAba + "/Data de nascimento do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.dataNascimento.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.dataNascimento.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c("el-date-picker", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "##/##/#####",
                                        expression: "'##/##/#####'"
                                      }
                                    ],
                                    staticClass: "input full-width",
                                    class: { erro: errors.length },
                                    attrs: {
                                      type: "date",
                                      name: "Data de nascimento",
                                      placeholder: "Selecione",
                                      format: "dd/MM/yyyy",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica
                                          .dataNascimento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "dataNascimento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.dataNascimento"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1740814740
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.hasConjuge &&
      _vm.cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil ===
        "VIUVO"
        ? _c(
            "div",
            [
              _c("app-divider", { attrs: { label: "Cônjuge" } }),
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.cpf.validacao"
                          ),
                          name: _vm.nomeAba + "/CPF do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.cpf.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.cpf.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "###.###.###-##",
                                        expression: "'###.###.###-##'"
                                      }
                                    ],
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "CPF" },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.cpf,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "cpf",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.cpf"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          588619604
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.nome.validacao"
                          ),
                          name: _vm.nomeAba + "/Nome do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.nome.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.nome.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "Nome", maxlength: "300" },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.nome,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "nome",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nome"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1248325568
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "labelDiv", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.apelido.validacao"
                          ),
                          name: _vm.nomeAba + "/Apelido do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.apelido.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.apelido.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      type: "text",
                                      maxlength: "300",
                                      name: "apelido"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica.apelido,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "apelido",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.apelido"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1934345267
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "inputDiv", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.possuiCertidaoObito.validacao"
                          ),
                          name: _vm.nomeAba + "/Possui certidão de óbito"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.possuiCertidaoObito.label"
                                      ),
                                      required: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.possuiCertidaoObito.obrigatorio"
                                      )
                                    }
                                  }),
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { label: true },
                                      on: {
                                        change: _vm.changePossuiCertidaoObito
                                      },
                                      model: {
                                        value:
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica
                                            .temCertidaoObito,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cadastroFormulario.interessado
                                              .conjuge.pessoa.pessoaFisica,
                                            "temCertidaoObito",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito"
                                      }
                                    },
                                    [_vm._v("Sim")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { label: false },
                                      on: {
                                        change: _vm.changePossuiCertidaoObito
                                      },
                                      model: {
                                        value:
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica
                                            .temCertidaoObito,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cadastroFormulario.interessado
                                              .conjuge.pessoa.pessoaFisica,
                                            "temCertidaoObito",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito"
                                      }
                                    },
                                    [_vm._v("Não")]
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          790404648
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.camposValidacao(
                            "conjuge.pessoaFisica.dataNascimento.validacao"
                          ),
                          name: _vm.nomeAba + "/Data de nascimento do cônjuge"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.camposValidacao(
                                        "conjuge.pessoaFisica.dataNascimento.label"
                                      ),
                                      required: true
                                    }
                                  }),
                                  _c("el-date-picker", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "##/##/#####",
                                        expression: "'##/##/#####'"
                                      }
                                    ],
                                    staticClass: "input full-width",
                                    class: { erro: errors.length },
                                    attrs: {
                                      type: "date",
                                      name: "Data de nascimento",
                                      placeholder: "Selecione",
                                      format: "dd/MM/yyyy",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario.interessado
                                          .conjuge.pessoa.pessoaFisica
                                          .dataNascimento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario.interessado
                                            .conjuge.pessoa.pessoaFisica,
                                          "dataNascimento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.dataNascimento"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          281148515
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb88594e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb88594e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPessoaFisicaRetificacao.vue
// module id = null
// module chunks = 